module.exports = __webpack_public_path__ + "static/img/products_banner.jpg";